import { RefreshCcw } from "lucide-react";
import { Button } from "src/@/components/ui/button";
import { Switch } from "src/@/components/ui/switch";
import { useOrders } from "../../orders-context";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "src/@/components/ui/popover";
import { Label } from "src/@/components/ui/label";
import { Trans } from "@lingui/react/macro";

export const OrdersRefundPicker = () => {
    const { refunded, setRefunded } = useOrders();

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant={refunded ? "default" : "outline"}
                    size="sm"
                    className="flex items-center"
                    icon={RefreshCcw}
                >
                    <span className="hidden lg:block "><Trans>Refunded</Trans></span>
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[200px] p-3">
                <div className="space-y-2 flex flex-col">
                    <Label htmlFor="refund-switch" className="text-sm">
                        <Trans>Show refunded only</Trans>
                    </Label>
                    <Switch
                        id="refund-switch"
                        checked={refunded}
                        onCheckedChange={setRefunded}
                    />
                </div>
            </PopoverContent>
        </Popover>
    );
};
